export default {
  get: function(){
    return {
      survey: {
        id: null,
        name: null,
        credits: null,
        completed: null,
        canComplete: null,
        calendarId: null
      },
      sections:[],
      api:{
        get:{
          fetching: null,
          error: false,
          values: {}
        },
        put: {
        },
        post:{
          answer:{
            sending: false
          }
        },
        delete:{
        }
      }
    }
  }
}
